<template>
  <div v-if="!isMobile()">
    <div class="page-header clear-filter" filter-color="black5">
      <div style="margin-top: 106px; height: 1600px; width: 100%">
        <div
          style="
            position: absolute;
            top: 80px;
            left: calc(50% - 640px);
            width: 1280px;
            height: calc(100% - 367px);
          "
        >
          <div
            class="bg_drago"
            style="position: absolute; top: 70px; left: 0px"
            id="player-container"
          >
            <!-- <div
              class="big_frame_grade_1"
              style="
                position: absolute;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
              "
              v-if="drago.grade == 1 || drago.grade == 2"
            ></div>
            <div
              class="big_frame_grade_2"
              style="
                position: absolute;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
              "
              v-if="drago.grade == 3 || drago.grade == 4"
            ></div>
            <div
              class="big_frame_grade_3"
              style="
                position: absolute;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
              "
              v-if="drago.grade == 5 || drago.grade == 6"
            ></div>
            <div
              class="big_frame_grade_4"
              style="
                position: absolute;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
              "
              v-if="drago.grade == 7"
            ></div>
            <img
              v-if="drago.tokenId >= 10001 && drago.tokenId <= 20000"
              src="/img/genesis-label.png"
              style="position: absolute; top: 16px; left: 16px"
            />
            <div
              v-if="drago.grade > 0"
              style="position: absolute; right: 10px; width: 62px; height: 64px"
            >
              <img
                v-bind:src="`/img/legendary-base-${drago.grade}.png`"
                style="position: absolute; left: 0px; top: 0px"
              />
              <div
                style="
                  position: absolute;
                  left: 0px;
                  top: 0px;
                  width: 100%;
                  padding-top: 12px;
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: 900;
                  text-align: center;
                  color: #fff;
                "
              >
                {{ drago.grade }}
              </div>
            </div> -->
          </div>
          <div
            style="
              position: absolute;
              left: 560px;
              top: 70px;
              width: calc(100% - 560px);
              height: calc(100% - 70px);
            "
          >
            <div
              style="
                font-family: Poppins;
                font-size: 32px;
                font-weight: 600;
                letter-spacing: -0.8px;
                text-align: left;
                color: #fff;
              "
            >
              Drago #{{ drago.tokenId }}
            </div>
            <div style="width: 100%; height: 40px; margin-top: 20px">
              <img
                v-if="drago.tokenId >= 10001 && drago.tokenId <= 20000"
                src="/img/genesis-label.png"
                style="float: left; margin-right: 10px"
              />
              <img
                v-if="drago.grade >= 1"
                v-bind:src="`/img/legendary-0${drago.grade}.png`"
                style="float: left; margin-right: 10px"
              />
              <div
                v-if="drago.rehatching > 0"
                @click="rehatch(drago.tokenId)"
                style="
                  float: right;
                  font-family: Poppins;
                  font-size: 13px;
                  font-weight: 500;
                  line-height: 3.23;
                  letter-spacing: -0.33px;
                  text-align: center;
                  cursor: pointer;
                  color: #7e8499;
                "
              >
                <img src="/img/mydrago/icon-rehatching.png" />
                <span style="margin-left: 10px">Rehatch</span>
              </div>
            </div>
            <div class="bg_head" style="margin-top: 50px">
              <div
                style="
                  width: 28px;
                  height: 28px;
                  padding: 3px 13px;
                  border-radius: 8px;
                  border: solid 0 #000;
                  background-color: #21264e;
                  display: inline-block;
                  margin-left: 20px;
                  margin-top: 16px;
                "
              >
                <img src="/img/icon-about.png" />
              </div>
              <span
                style="
                  display: inline-block;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  text-align: left;
                  color: #fff;
                  margin-left: 13px;
                  vertical-align: middle;
                "
              >
                INFO
              </span>
              <div
                style="
                  display: inline-block;
                  float: right;
                  margin-right: 18px;
                  margin-top: 18px;
                "
              >
                <img
                  src="/img/sel-arr-copy-2.png"
                  style="transform: scaleY(-1)"
                />
              </div>
            </div>
            <div
              style="
                width: 100%;
                padding: 30px 16px;
                border: solid 0 #000;
                background-color: #080a1f;
              "
            >
              <div class="text_category" style="margin-top: 10px">
                <span style="display: inline-block; width: 30%"
                  >BREED COUNT</span
                >
                <span style="display: inline-block">OWNER BY</span>
              </div>
              <div class="text_content" style="margin-top: 20px">
                <span style="display: inline-block; width: 30%"
                  >{{ drago.breed }}/7</span
                >
                <span style="display: inline-block">{{ drago.owner }}</span>
              </div>
              <div class="category_line" style="margin-top: 24px"></div>
              <div class="text_category" style="margin-top: 24px">
                PARTS & STATS
              </div>
              <div
                class="div_stat"
                v-for="(stat, index) in dragoStats"
                v-bind:key="index"
              >
                <div v-if="stat.grade == 1">
                  <div
                    style="
                      display: inline-block;
                      width: 50px;
                      height: 50px;
                      vertical-align: middle;
                    "
                  >
                    <img
                      v-bind:src="getPartsImg(index)"
                      style="position: absolute"
                    />
                  </div>
                  <span
                    style="
                      margin-left: 20px;
                      width: 80px;
                      font-family: Poppins;
                      font-size: 16px;
                      text-align: left;
                      color: #fff;
                      display: inline-block;
                      vertical-align: middle;
                    "
                  >
                    {{ partsName[index] }}
                  </span>
                  <span
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 300px;
                      font-family: Poppins;
                      font-size: 16px;
                      text-align: left;
                      color: #fff;
                      display: inline-block;
                      vertical-align: middle;
                    "
                    v-bind:title="`${
                      abilities[dragoStats[index].ability.code]
                    }`"
                  >
                    {{ abilities[dragoStats[index].ability.code] }}
                  </span>
                  <span
                    style="
                      margin-left: 20px;
                      width: 70px;
                      font-family: Poppins;
                      font-size: 16px;
                      text-align: left;
                      color: #fff;
                      display: inline-block;
                      vertical-align: middle;
                    "
                  >
                    +{{ (dragoStats[index].ability.value * 100).toFixed(1) }}%
                  </span>
                  <span
                    v-if="dragoStats[index].bonus > 0"
                    style="
                      width: 50px;
                      font-family: Poppins;
                      font-size: 16px;
                      text-align: left;
                      color: #2bd690;
                      display: inline-block;
                      vertical-align: middle;
                    "
                  >
                    +{{ (dragoStats[index].bonus * 100).toFixed(1) }}%
                  </span>
                </div>
                <div v-if="stat.grade == 2">
                  <div
                    style="
                      display: inline-block;
                      width: 50px;
                      height: 50px;
                      vertical-align: middle;
                    "
                  >
                    <img
                      v-bind:src="getPartsImg(index)"
                      style="position: absolute"
                    />
                    <img
                      v-bind:src="getPartsFrame(index)"
                      style="position: absolute"
                    />
                  </div>
                  <span
                    style="
                      margin-left: 20px;
                      width: 80px;
                      font-family: Poppins;
                      font-size: 16px;
                      text-align: left;
                      color: #ffde1b;
                      display: inline-block;
                      vertical-align: middle;
                    "
                  >
                    {{ partsName[index] }}
                  </span>
                  <span
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 300px;
                      font-family: Poppins;
                      font-size: 16px;
                      text-align: left;
                      color: #fff;
                      display: inline-block;
                      vertical-align: middle;
                    "
                    v-bind:title="`${
                      abilities[dragoStats[index].ability.code]
                    }`"
                  >
                    {{ abilities[dragoStats[index].ability.code] }}
                  </span>
                  <span
                    style="
                      margin-left: 20px;
                      width: 70px;
                      font-family: Poppins;
                      font-size: 16px;
                      text-align: left;
                      color: #fff;
                      display: inline-block;
                      vertical-align: middle;
                    "
                  >
                    +{{ (dragoStats[index].ability.value * 100).toFixed(1) }}%
                  </span>
                  <span
                    v-if="dragoStats[index].bonus > 0"
                    style="
                      width: 50px;
                      font-family: Poppins;
                      font-size: 16px;
                      text-align: left;
                      color: #2bd690;
                      display: inline-block;
                      vertical-align: middle;
                    "
                  >
                    +{{ (dragoStats[index].bonus * 100).toFixed(1) }}%
                  </span>
                </div>
              </div>
              <div
                class="text_category"
                style="margin-top: 40px; margin-bottom: 4px"
              >
                BONUS
              </div>
              <div
                style="width: 100%; height: 28px; margin-top: 16px"
                v-for="(bonus, bonusIndex) in dragoBonus"
                v-bind:key="`bonus_${bonusIndex}`"
              >
                <div class="bg_bonus">Bonus {{ bonusIndex + 1 }}</div>
                <span
                  style="
                    overflow: hidden;
                    margin-left: 20px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 300px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  {{ abilities[bonus.code] }}
                </span>
                <span
                  style="
                    margin-left: 10px;
                    width: 70px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  +{{ (bonus.value * 100).toFixed(1) }}%
                </span>
              </div>
            </div>
            <div class="bg_head" style="margin-top: 50px">
              <div
                style="
                  width: 28px;
                  height: 28px;
                  padding: 3px 13px;
                  border-radius: 8px;
                  border: solid 0 #000;
                  background-color: #21264e;
                  display: inline-block;
                  margin-left: 20px;
                  margin-top: 16px;
                "
              >
                <img src="/img/icon-about.png" />
              </div>
              <span
                style="
                  display: inline-block;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  text-align: left;
                  color: #fff;
                  margin-left: 13px;
                  vertical-align: middle;
                "
              >
                RENTAL INFO
              </span>
              <div
                style="
                  display: inline-block;
                  float: right;
                  margin-right: 18px;
                  margin-top: 18px;
                "
              >
                <img
                  src="/img/sel-arr-copy-2.png"
                  style="transform: scaleY(-1)"
                />
              </div>
            </div>
            <div
              style="
                width: 100%;
                padding: 30px 16px;
                border: solid 0 #000;
                background-color: #080a1f;
              "
            >
              <div
                class="text_category"
                style="margin-top: 0px; margin-bottom: 20px"
              >
                CONTRACT
              </div>
              <div style="height: 30px">
                <span
                  style="
                    margin-left: 20px;
                    width: 200px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  RENTEE
                </span>
                <span
                  v-if="isRental()"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 400px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #0d6eff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  {{ drago.rent.to }}
                </span>
                <span
                  v-else
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 300px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  -
                </span>
              </div>
              <div style="height: 30px">
                <span
                  style="
                    margin-left: 20px;
                    width: 200px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  DISTRIBUTION RATIO
                </span>
                <span
                  v-if="isRental()"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 300px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  {{ drago.rent.profitShareRatio * 10 }} :
                  {{ 10 - drago.rent.profitShareRatio * 10 }} (OWNER : RENTEE)
                </span>
                <span
                  v-else
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 300px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  -
                </span>
              </div>
              <div style="height: 30px">
                <span
                  style="
                    margin-left: 20px;
                    width: 200px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  TERM
                </span>
                <span
                  v-if="isRental()"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 400px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  {{ drago.rent.startDate | date }} ~
                  {{ drago.rent.expireDate | date }}
                </span>
                <span
                  v-else
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 400px;
                    font-family: Poppins;
                    font-size: 16px;
                    text-align: left;
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                  "
                >
                  -
                </span>
              </div>
              <div class="category_line" style="margin-top: 24px"></div>
              <div
                v-if="isMyDrago() && !isRental()"
                @click="onClickRental()"
                style="
                  width: 280px;
                  height: 70px;
                  margin-top: 30px;
                  margin-left: calc(50% - 140px);
                  padding-top: 24px;
                  border-radius: 8px;
                  box-shadow: 0px 10px 10px 0 rgba(0, 102, 255, 0.2);
                  border: solid 0 #000;
                  background-image: linear-gradient(to right, #008aff, #0054ff);
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  text-align: center;
                  color: #fff;
                  cursor: pointer;
                "
              >
                RENTAL
              </div>
              <div
                v-if="isMyDrago() && isRental()"
                @click="onClickCancelRental()"
                style="
                  width: 280px;
                  height: 70px;
                  margin-top: 30px;
                  margin-left: calc(50% - 140px);
                  padding-top: 24px;
                  border-radius: 8px;
                  border: solid 0 #000;
                  background-color: #13132d;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  text-align: center;
                  color: #fff;
                  cursor: pointer;
                "
              >
                CANCEL RENTAL
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            position: fixed;
            left: 0px;
            top: 0px;
            width: 100vw;
            height: 100vh;
            background-color: #00000099;
            cursor: pointer;
            z-index: 900;
          "
          v-if="
            modals.sell == true ||
            modals.rental == true ||
            modals.cancel_rental == true ||
            modals.make_offer == true ||
            modals.rehatching_egg == true ||
            modals.confirm_rehatch == true
          "
          @click="closeAllPopup()"
        ></div>
        <div
          v-if="modals.rehatching_egg"
          style="
            position: fixed;
            top: calc((100% - 640px) / 2);
            left: calc((100% - 560px) / 2);
            padding-top: 32px;
            text-align: center;
            width: 640px;
            height: 560px;
            background-image: url('/img/mydrago/popupbase.png');
            z-index: 10000;
          "
        >
          <div
            class="popup-head-text"
            style="position: absolute; left: 0px; top: 20px; width: 100%"
          >
            Rehatching processing
          </div>
          <div
            class="popup-content-text"
            style="
              position: absolute;
              left: 5%;
              top: 160px;
              width: 90%;
              height: 200px;
            "
          >
            Wait for rehatching drago...<br /><br />
            It may take up to 20-60 minutes depending on the Ethereum network &
            Chainlink VRF situation.<br /><br />
            After rehatching, you can see the drago in your inventory.
          </div>
          <!-- <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 150px"
      ></div> -->
          <div
            style="
              position: absolute;
              top: 450px;
              left: 0px;
              width: 640px;
              height: 110px;
              border: solid 0 #fff;
              background-color: #e6e7ec;
            "
          >
            <div
              @click="closeAllPopup()"
              class="popup-btn"
              style="
                position: absolute;
                left: 180px;
                top: 20px;
                cursor: pointer;
              "
            >
              OK
            </div>
          </div>
        </div>
        <div
          v-if="modals.confirm_rehatch == true"
          style="
            position: fixed;
            top: calc((100% - 640px) / 2);
            left: calc((100% - 560px) / 2);
            padding-top: 32px;
            text-align: center;
            width: 640px;
            height: 560px;
            background-image: url('/img/mydrago/popupbase.png');
            z-index: 10000;
          "
        >
          <div
            class="popup-head-text"
            style="position: absolute; left: 0px; top: 20px; width: 100%"
          >
            Confirm rehatch
          </div>
          <div
            class="popup-content-text"
            style="
              position: absolute;
              left: 5%;
              top: 180px;
              width: 90%;
              height: 200px;
            "
          >
            Due to the error in the transaction, we give you a chance to
            re-hatch the Drago. <br />
            It will reroll the parts following the Drago Genesis rule.
            <br /><br />
            This action can only be done once, and it is impossible to revert
            this action.
          </div>
          <!-- <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 150px"
      ></div> -->
          <div
            style="
              position: absolute;
              top: 450px;
              left: 0px;
              width: 640px;
              height: 110px;
              border: solid 0 #fff;
              background-color: #e6e7ec;
            "
          >
            <div
              @click="onClickOKRehatching()"
              class="popup-btn"
              style="
                position: absolute;
                left: 60px;
                top: 20px;
                cursor: pointer;
                width: 240px;
              "
            >
              Confirm
            </div>
            <div
              @click="closeAllPopup()"
              class="popup-btn"
              style="
                position: absolute;
                right: 60px;
                top: 20px;
                cursor: pointer;
                width: 240px;
              "
            >
              Cancel
            </div>
          </div>
        </div>
        <div
          v-if="modals.rental"
          style="
            width: 640px;
            height: 534px;
            position: fixed;
            top: calc(50% - 267px);
            left: calc(50% - 320px);
            border-radius: 8px;
            border: solid 0 #fff;
            background-color: #fff;
            z-index: 100000;
          "
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 0px;
              width: 640px;
              height: 80px;
              border: solid 0 #fff;
              background-color: #e9edf3;
            "
          >
            <div
              style="
                font-family: Poppins;
                font-size: 28px;
                font-weight: 600;
                text-align: left;
                color: #000;
                margin-left: 32px;
                margin-top: 19px;
                display: inline-block;
              "
            >
              Rental
            </div>
            <img
              src="/img/icon-close-white.png"
              style="
                float: right;
                display: inline-block;
                margin-top: 30px;
                margin-right: 30px;
                cursor: pointer;
              "
              @click="closeAllPopup()"
            />
          </div>
          <div
            style="
              position: absolute;
              top: 100px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            RENTEE
          </div>

          <div
            style="
              position: absolute;
              top: 132px;
              left: 30px;
              width: 580px;
              height: 48px;
            "
          >
            <input
              type="text"
              v-model="input_rentee"
              style="
                display: inline-block;
                width: 400px;
                height: 48px;
                padding-left: 20px;
                padding-right: 20px;
                border-radius: 8px;
                border: solid 1px #dfe5ef;
                text-align: left;
                position: absolute;
                background-color: #fff;
              "
            />
          </div>
          <div
            style="
              position: absolute;
              top: 200px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            DISTRIBUTION RATIO (OWNER : RENTEE)
          </div>
          <div
            style="
              position: absolute;
              top: 232px;
              left: 30px;
              width: 580px;
              height: 48px;
            "
          >
            <div class="selectBox" style="display: inline-block">
              <select name="duration" v-model="input_rent_ratio" class="select">
                <option value="9">9 : 1</option>
                <option value="8">8 : 2</option>
                <option value="7">7 : 3</option>
                <option value="6">6 : 4</option>
                <option value="5">5 : 5</option>
                <option value="4">4 : 6</option>
                <option value="3">3 : 7</option>
                <option value="2">2 : 8</option>
                <option value="1">1 : 9</option>
              </select>
              <span class="icoArrow"
                ><img src="/img/sel-arr-copy-3.png" alt=""
              /></span>
            </div>
          </div>
          <div
            style="
              position: absolute;
              top: 300px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            DURATION
          </div>
          <div
            style="
              position: absolute;
              top: 327px;
              left: 30px;
              width: 580px;
              height: 48px;
            "
          >
            <div class="selectBox" style="display: inline-block">
              <select
                name="duration"
                v-model="input_rent_duration"
                class="select"
              >
                <option value="7">7 Days</option>
                <option value="30">30 Days</option>
                <option value="90">90 Days</option>
                <option value="365">365 Days</option>
              </select>
              <span class="icoArrow"
                ><img src="/img/sel-arr-copy-3.png" alt=""
              /></span>
            </div>
          </div>
          <div
            class="line-copy-3"
            style="position: absolute; top: 383px; left: 30px"
          ></div>
          <div style="
              position: absolute;
              bottom: 70px;
              width: 90%;
              left: 5%;
              height: 70px;
              font-family: Poppins;
              font-size: 14px;
              font-weight: 600;
              text-align: center;
              color: #ff0000;
            ">
            Warning: Changing the ownership or rental status of your Drago will result in the cancellation of any ongoing resource minting with the Drago. 
          </div>
          <div
            style="
              position: absolute;
              bottom: 20px;
              left: 180px;
              width: 280px;
              height: 70px;
              padding-top: 22px;
              border-radius: 8px;
              box-shadow: 0px 10px 10px 0 rgba(0, 102, 255, 0.2);
              border: solid 0 #000;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #fff;
              background-image: linear-gradient(to right, #008aff, #0054ff);
              cursor: pointer;
            "
            @click="rentalStart()"
          >
            RENTAL
          </div>
        </div>
        <div
          v-if="modals.cancel_rental"
          style="
            width: 600px;
            height: 254px;
            position: fixed;
            top: calc(50% - 127px);
            left: calc(50% - 300px);
            border-radius: 8px;
            border: solid 0 #fff;
            background-color: #fff;
            z-index: 100000;
          "
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 0px;
              width: 600px;
              height: 60px;
              border: solid 0 #fff;
              background-color: #f85e49;
            "
          >
            <div
              style="
                font-family: Poppins;
                font-size: 24px;
                font-weight: 500;
                text-align: left;
                color: #fff;
                margin-left: 32px;
                margin-top: 12px;
                display: inline-block;
              "
            >
              Rental Cancellation
            </div>
            <img
              src="/img/icon-close-black.png"
              style="
                float: right;
                display: inline-block;
                margin-top: 20px;
                margin-right: 30px;
                cursor: pointer;
              "
              @click="closeAllPopup()"
            />
          </div>
          <div
            style="
              position: absolute;
              top: 100px;
              font-family: Poppins;
              width: 100%;
              font-size: 16px;
              font-weight: 500;
              text-align: center;
              color: #202431;
            "
          >
            Do you want to cancel the rental?
          </div>
          <div
            style="
              position: absolute;
              left: calc(50% - 90px);
              bottom: 30px;
              width: 180px;
              height: 48px;
              border-radius: 4px;
              border: solid 0 #000;
              background-color: #13132d;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #fff;
              padding-top: 10px;
              cursor: pointer;
            "
            @click="rentalCancel()"
          >
            CANCEL RENTAL
          </div>
        </div>
        <div
          v-if="modals.sell"
          style="
            width: 640px;
            height: 534px;
            position: fixed;
            top: calc(50% - 267px);
            left: calc(50% - 320px);
            border-radius: 8px;
            border: solid 0 #fff;
            background-color: #fff;
            z-index: 100000;
          "
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 0px;
              width: 640px;
              height: 80px;
              border: solid 0 #fff;
              background-color: #e9edf3;
            "
          >
            <div
              style="
                font-family: Poppins;
                font-size: 28px;
                font-weight: 600;
                text-align: left;
                color: #000;
                margin-left: 32px;
                margin-top: 19px;
                display: inline-block;
              "
            >
              List item for sale
            </div>
            <img
              src="/img/icon-close.png"
              style="
                float: right;
                display: inline-block;
                margin-top: 30px;
                margin-right: 30px;
                cursor: pointer;
              "
              @click="closeAllPopup()"
            />
          </div>
          <div
            style="
              position: absolute;
              top: 110px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            PRICE
          </div>

          <div
            style="
              position: absolute;
              top: 142px;
              left: 30px;
              width: 580px;
              height: 48px;
            "
          >
            <div class="selectBox" style="display: inline-block">
              <select
                name="token_type"
                v-model="input_token_type"
                class="select"
              >
                <option value="ETH">ETH</option>
                <option value="LOKA">LOKA</option>
              </select>
              <span class="icoArrow"
                ><img src="/img/sel-arr-copy-3.png" alt=""
              /></span>
            </div>
            <input
              type="text"
              v-model="input_price"
              style="
                display: inline-block;
                width: 370px;
                height: 48px;
                padding-left: 20px;
                padding-right: 20px;
                border-radius: 8px;
                border: solid 1px #dfe5ef;
                text-align: left;
                position: absolute;
                background-color: #fff;
                margin-left: 10px;
              "
            />
          </div>
          <div
            style="
              position: absolute;
              top: 220px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            DURATION
          </div>
          <div
            style="
              position: absolute;
              top: 252px;
              left: 30px;
              width: 580px;
              height: 48px;
            "
          >
            <div class="selectBox" style="display: inline-block">
              <select name="duration" v-model="input_duration" class="select">
                <option value="1">1 Day</option>
                <option value="3">3 Days</option>
                <option value="7">7 Days</option>
                <option value="10">10 Days</option>
                <option value="30">30 Days</option>
              </select>
              <span class="icoArrow"
                ><img src="/img/sel-arr-copy-3.png" alt=""
              /></span>
            </div>
          </div>
          <div
            style="
              position: absolute;
              top: 330px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            FEES
          </div>
          <div
            style="
              position: absolute;
              top: 362px;
              left: 30px;
              font-family: Poppins;
              font-size: 14px;
              letter-spacing: -0.35px;
              text-align: left;
              color: #444;
            "
          >
            3%
          </div>
          <div
            class="line-copy-3"
            style="position: absolute; top: 403px; left: 30px"
          ></div>
          <div
            style="
              position: absolute;
              bottom: 30px;
              left: 180px;
              width: 280px;
              height: 70px;
              padding-top: 22px;
              border-radius: 8px;
              box-shadow: 0px 10px 10px 0 rgba(0, 102, 255, 0.2);
              border: solid 0 #000;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #fff;
              background-image: linear-gradient(to right, #008aff, #0054ff);
              cursor: pointer;
            "
            @click="listItem()"
          >
            LIST ITEM
          </div>
        </div>
        <div
          v-if="modals.make_offer"
          style="
            width: 640px;
            height: 600px;
            position: fixed;
            top: calc(50% - 300px);
            left: calc(50% - 320px);
            border-radius: 8px;
            border: solid 0 #fff;
            background-color: #fff;
            z-index: 100000;
          "
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 0px;
              width: 640px;
              height: 80px;
              border: solid 0 #fff;
              background-color: #e9edf3;
            "
          >
            <div
              style="
                font-family: Poppins;
                font-size: 28px;
                font-weight: 600;
                text-align: left;
                color: #000;
                margin-left: 32px;
                margin-top: 19px;
                display: inline-block;
              "
            >
              Make an offer
            </div>
            <img
              src="/img/icon-close.png"
              style="
                float: right;
                display: inline-block;
                margin-top: 30px;
                margin-right: 30px;
                cursor: pointer;
              "
              @click="closeAllPopup()"
            />
          </div>
          <div
            style="
              position: absolute;
              top: 110px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            CURRENT PRICE
          </div>
          <div
            style="
              position: absolute;
              top: 150px;
              left: 30px;
              font-family: Poppins;
              font-size: 14px;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            Not for sale
          </div>
          <div
            style="
              position: absolute;
              top: 200px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            PRICE
          </div>

          <div
            style="
              position: absolute;
              top: 232px;
              left: 30px;
              width: 580px;
              height: 48px;
            "
          >
            <div class="selectBox" style="display: inline-block">
              <select
                name="token_type"
                v-model="input_offer_token_type"
                class="select"
              >
                <option value="ETH">ETH</option>
                <option value="LOKA">LOKA</option>
              </select>
              <span class="icoArrow"
                ><img src="/img/sel-arr-copy-3.png" alt=""
              /></span>
            </div>
            <input
              type="text"
              v-model="input_offer_price"
              style="
                display: inline-block;
                width: 370px;
                height: 48px;
                padding-left: 20px;
                padding-right: 20px;
                border-radius: 8px;
                border: solid 1px #dfe5ef;
                text-align: left;
                position: absolute;
                background-color: #fff;
                margin-left: 10px;
              "
            />
          </div>
          <div
            style="
              position: absolute;
              top: 310px;
              left: 30px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.31;
              text-align: left;
              color: #202431;
            "
          >
            DURATION
          </div>
          <div
            style="
              position: absolute;
              top: 342px;
              left: 30px;
              width: 580px;
              height: 48px;
            "
          >
            <div class="selectBox" style="display: inline-block">
              <select
                name="duration"
                v-model="input_offer_duration"
                class="select"
              >
                <option value="1">1 Day</option>
                <option value="3">3 Days</option>
                <option value="7">7 Days</option>
                <option value="10">10 Days</option>
                <option value="30">30 Days</option>
              </select>
              <span class="icoArrow"
                ><img src="/img/sel-arr-copy-3.png" alt=""
              /></span>
            </div>
          </div>
          <div
            class="line-copy-3"
            style="position: absolute; top: 473px; left: 30px"
          ></div>
          <div
            style="
              position: absolute;
              bottom: 30px;
              left: 180px;
              width: 280px;
              height: 70px;
              padding-top: 22px;
              border-radius: 8px;
              box-shadow: 0px 10px 10px 0 rgba(0, 102, 255, 0.2);
              border: solid 0 #000;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #fff;
              background-image: linear-gradient(to right, #008aff, #0054ff);
              cursor: pointer;
            "
            @click="makeOffer()"
          >
            MAKE OFFER
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal, Button } from "@/components";

import config from "../config.js";
import axios from "axios";
import moment from "moment";
import { hatchDrago, rehatchDrago, connectWallet, sign } from "../utils/wallet";

export default {
  name: "dragodetail",
  bodyClass: "dragodetail-page",
  components: {
    [Button.name]: Button,
  },
  computed: {},
  mounted: async function () {
    await this.load();

    setInterval(() => {
      this.saleRemainTime = 0;
    }, 1000);
  },
  beforeDestroy: function () {},
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    closeAllPopup() {
      this.modals.sell = false;
      this.modals.make_offer = false;
      this.modals.rehatching_egg = false;
      this.modals.confirm_rehatch = false;
      this.modals.rental = false;
      this.modals.cancel_rental = false;
    },
    closeModal(modal) {
      this.modals[modal] = false;
    },
    openModal(modal) {
      this.closeAllPopup();
      this.modals[modal] = true;
    },
    load: async function () {
      await connectWallet(this.$store);

      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      let ret = await axios.post(`${config.api.nft_url}/market/detail`, {
        tokenId: this.$route.params.tokenId,
        address: address,
      });

      if (ret.data.result == true) {
        console.log(ret.data);

        this.drago = ret.data.drago;
        this.dragoStats = ret.data.stats;
        this.dragoBonus = ret.data.bonus;

        setTimeout(() => {
          let rThis = this;

          new spine.SpinePlayer(`player-container`, {
            showControls: false,
            jsonUrl: "/drago/drago/nft_drago.json",
            atlasUrl: "/drago/drago/nft_drago.atlas.txt",
            backgroundColor: "#07071f",
            success: function (player) {
              var indexs = [0, 0, 0, 0, 0, 0, 0];
              let data = rThis.drago.datas;
              for (let j = 0; j < 7; ++j) {
                if (rThis.dragoStats[j].grade == 2) {
                  indexs[j] = rThis.dragoStats[j].attr * 10 + 10;
                } else {
                  indexs[j] =
                    rThis.dragoStats[j].attr * 10 + rThis.dragoStats[j].code;
                }
              }

              player.skeleton.setAttachment("head", `head/head_${indexs[2]}`);

              player.skeleton.setAttachment(
                "horn_left",
                `horn/horn_${indexs[0]}_l`
              );
              player.skeleton.setAttachment(
                "horn_right",
                `horn/horn_${indexs[0]}_r`
              );

              player.skeleton.setAttachment("eye", `eye/eye_${indexs[1]}`);

              player.skeleton.setAttachment("body", `body/body_${indexs[3]}`);

              player.skeleton.setAttachment(
                "wing_left",
                `wing/wing_${indexs[4]}_l1`
              );
              player.skeleton.setAttachment(
                "wing_right",
                `wing/wing_${indexs[4]}_r1`
              );

              player.skeleton.setAttachment(
                "leg_left",
                `leg/leg_${indexs[5]}_l`
              );
              player.skeleton.setAttachment(
                "leg_right",
                `leg/leg_${indexs[5]}_r`
              );

              player.skeleton.setAttachment("tail", `tail/tail_${indexs[6]}`);
            },
          });
        }, 1000);
      }
    },
    onClickRental() {
      this.closeAllPopup();

      this.openModal("rental");
    },
    onClickCancelRental() {
      this.closeAllPopup();

      this.openModal("cancel_rental");
    },
    async onClickOKRehatching() {
      this.closeAllPopup();

      let tokenId = this.drago.tokenId;
      let self = this;
      //
      rehatchDrago(this.$store, tokenId)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
          self.openModal("rehatching_egg");
          // self.openModal("claim_egg");
          // await self.startHatching(tokenId, txHash);
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          // console.log(parseInt(receipt.logs[0].topics[3], 16));
          // self.openModal("claim_drago");
          // resolve({result: true, data: receipt});
          // await self.getDragoInventory();
          await self.load();
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          if (error != null) {
            alert(error);
          }
        });
    },
    rehatch(tokenId) {
      this.openModal("confirm_rehatch");
    },
    getPartsImg(slot) {
      if (this.drago.datas == null) {
        return "";
      }
      const partsName = ["horn", "eye", "head", "body", "wing", "leg", "tail"];
      const attrName = ["red", "blue", "yellow", "green", "purple"];
      let partsAttr = this.drago.datas[3 + slot * 5 + 2] - 1;
      return `/img/parts/icon_${partsName[slot]}_${attrName[partsAttr]}.png`;
    },
    getPartsFrame(slot) {
      if (this.drago.datas == null) {
        return "";
      }
      const gradeName = ["frame_drago_epic", "frame_drago_legend"];
      let grade = this.drago.datas[3 + slot * 5];
      if (grade == 1) {
        return "";
      }
      return `/img/parts/${gradeName[grade - 1]}.png`;
    },
    isMyDrago() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      if (this.isRental()) {
        if (this.drago.rent.from == address) {
          return true;
        }
      } else {
        if (this.drago.rent != null && this.drago.rent.status == 1 && new Date(this.drago.rent.expireDate).getTime() < new Date().getTime()) {
          if (this.drago.rent.from == address) {
            return true;
          }
        }  
        if (this.drago.owner == address) {
          return true;
        }
      }
      return false;
    },
    isRental() {
      console.log(this.drago);
      if (this.drago.rent != null && this.drago.rent.status == 1) {
        if (
          new Date(this.drago.rent.expireDate).getTime() > new Date().getTime()
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    listItem() {
      console.log(this.drago.tokenId);
      console.log(this.input_token_type);
      console.log(this.input_price);
      console.log(this.input_duration);
      this.closeAllPopup();
    },
    makeOffer() {
      console.log(this.drago.tokenId);
      console.log(this.input_offer_token_type);
      console.log(this.input_offer_price);
      console.log(this.input_offer_duration);
      this.closeAllPopup();
    },
    async rentalStart() {
      this.closeAllPopup();

      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }
      let signed = await sign(this.$store, this.input_rentee.toLowerCase()+"_"+this.drago.tokenId);
      console.log(signed)
      let ret = await axios.post(`${config.api.game_url}/drago/rent/direct`, {
        address: address,
        rentAddress: this.input_rentee,
        tokenId: this.drago.tokenId,
        expireTime:this.input_rent_duration * 86400,
        shareRatio:this.input_rent_ratio,
        signed: signed
      });

      if (ret.data.result == true) {
        await this.load();
      }
    },
    async rentalCancel() {
      this.closeAllPopup();

      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }
      let signed = await sign(this.$store, this.drago.rent.to+"_"+this.drago.tokenId);

      let ret = await axios.post(`${config.api.game_url}/drago/rent/cancel`, {
        address: address,
        rentAddress: this.drago.rent.to,
        tokenId: this.drago.tokenId,
        signed: signed
      });

      if (ret.data.result == true) {
        await this.load();
      }
    }
  },
  filters: {
    comma(val) {
      return Number(val).toLocaleString("en-US");
      //return String(val).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm");
      }
    },
  },
  data() {
    return {
      modals: {
        rehatching_egg: false,
        confirm_rehatch: false,
        sell: false,
        make_offer: false,
        rental: false,
        cancel_rental: false,
      },
      input_rent_ratio: 5,
      input_rent_duration: 30,
      input_rentee: "",
      input_duration: 1,
      input_token_type: "ETH",
      input_price: 0,
      input_offer_duration: 1,
      input_offer_token_type: "ETH",
      input_offer_price: 0,
      partsName: ["Horn", "Eye", "Head", "Body", "Wing", "Leg", "Tail"],
      drago: {},
      dragoStats: [],
      dragoBonus: [],
      partsSlots: [0, 1, 2, 3, 4, 5, 6],
      saleRemainTime: 0,
      abilities: {
        1: "Power",
        2: "Food Production",
        3: "Lumber Production",
        4: "Stone Production",
        5: "Gold Production",
        6: "Food storage capacity",
        7: "Lumber storage capacity",
        8: "Stone storage capacity",
        9: "Gold storage capacity",
        10: "VIP point",
        11: "Troop dispatch queue",
        12: "Marching troop capacity",
        13: "Troop Limit",
        14: "Research Speed",
        15: "Resource protection",
        16: "Scout Level",
        17: "Additional building queue",
        18: "Scout limit",
        19: "Maximum troop size for Rally",
        20: "Maximum reinforcement troop size",
        21: "Food Protection capacity",
        22: "Lumber Protection capacity",
        23: "Stone Protection capacity",
        24: "Gold Protection capacity",
        25: "Treasure slot",
        26: "Wall Durability",
        27: "Wall Attack buff",
        28: "Wall Defense buff",
        29: "Hospital Capacity",
        30: "Healing Speed",
        31: "Mortality reduction",
        32: "Alliance help Count",
        33: "Alliance help Speedup",
        34: "Alliance size",
        35: "Gathering Speed",
        36: "Construction Speed",
        37: "Food Gathering Speed",
        38: "Lumber Gathering Speed",
        39: "Stone Gathering Speed",
        40: "Gold Gathering Speed",
        41: "Crystal Gathering Speed",
        42: "Caravan Stocks",
        43: "Caravan Visit Interval",
        44: "Food",
        45: "Lumber",
        46: "Stone",
        47: "Gold",
        48: "Crystal",
        49: "Speedup",
        50: "Infantry HP",
        51: "Archery HP",
        52: "Cavalry HP",
        53: "Infantry Defense",
        54: "Archery Defense",
        55: "Cavalry Defense",
        56: "Infantry Attack",
        57: "Archery Attack",
        58: "Cavalry Attack",
        59: "Infantry Speed",
        60: "Archery Speed",
        61: "Cavalry Speed",
        62: "Infantry Load",
        63: "Archery Load",
        64: "Cavalry Load",
        65: "Troops HP",
        66: "Troops Defense",
        67: "Troops Attack",
        68: "Troops Speed",
        69: "Troops Load",
        70: "T2 Infantry Unlock",
        71: "T2 Archery Unlock",
        72: "T2 Cavalry Unlock",
        73: "T3 Infantry Unlock",
        74: "T3 Archery Unlock",
        75: "T3 Cavalry Unlock",
        76: "T4 Infantry Unlock",
        77: "T4 Archery Unlock",
        78: "T4 Cavalry Unlock",
        79: "T5 Infantry Unlock",
        80: "T5 Archery Unlock",
        81: "T5 Cavalry Unlock",
        82: "Troops Training Rate",
        83: "Troops Training Speed",
        84: "Troops Training Cost",
        85: "Random Teleport",
        86: "Advanced Teleport",
        87: "Defense mortality reduction bonus",
        88: "Infantry Training Rate",
        89: "Archery Training Rate",
        90: "Cavalry Training Rate",
        91: "Infantry Training Speed",
        92: "Archery Training Speed",
        93: "Cavalry Training Speed",
        94: "Infantry Training Cost",
        95: "Archery Training Cost",
        96: "Cavalry Training Cost",
        97: "Construction speed",
        98: "Research speed",
        99: "Training speed",
        100: "Action point",
        101: "Action point regeneration",
        102: "Healing speed",
        103: "Teleport",
        104: "Teleport 2",
        105: "Teleport 3",
        106: "Package opening",
        107: "Instant harvest",
        108: "Instant recall",
        109: "Resource production",
        110: "Name change",
        111: "King's Shield",
        112: "vs Monster HP",
        113: "vs Monster Defense",
        114: "vs Monster Attack",
        115: "Summon Monster",
        116: "Summon Resources",
        117: "Action point regeneration",
        118: "Daily Free Chest",
        119: "Resource reserves",
        120: "Dispel",
        121: "Dev point",
        122: "Alliance Teleport",
        123: "Resource box",
        124: "Speedup box",
        125: "Intercontinental Teleport",
        126: "Ban Advanced Teleport",
        127: "Ban Shield",
        128: "Recruit T1 Troops",
        129: "Spawn crystal mine Lv4",
        130: "Spawn crystal mine Lv5",
        131: "Candy drop rate x2",
        132: "Experience points",
        133: "Infantry HP when composed of infantry only",
        134: "Infantry defense when composed of infantry only",
        135: "Infantry attack when composed of infantry only",
        136: "Archer HP when composed of archer only",
        137: "Archer defense when composed of archer only",
        138: "Archer attack when composed of archer only",
        139: "Cavalry HP when composed of cavalry only",
        140: "Cavalry defense when composed of cavalry only",
        141: "Cavalry attack when composed of cavalry only",
        142: "Castle defending Infantry's defense",
        143: "Infantry HP against archer",
        144: "Infantry defense under 50% HP",
        145: "Castle defending Infantry's HP",
        146: "Infantry defense when participating a rally",
        147: "Infantry attack when invading enemy kingdom",
        148: "Castle defending archer's attack",
        149: "Archer's attack against cavalry",
        150: "Archer's attack for the first 2 turns",
        151: "Archer's defense when raiding resource gathering",
        152: "Archer's HP when participating a rally",
        153: "Cavalry's speed when raiding enemy kingdom",
        154: "Cavalry speed when raiding resource gathering",
        155: "Cavalry attack when marching over 200km",
        156: "Cavalry defense when marching over 200km",
        157: "Cavalry speed when composed of cavalry only",
        158: "Troop speed when participating in a rally",
        159: "Troop attack when raiding collectors",
        160: "Troop HP when composed of all troop types",
        161: "Troop defense when composed of all troop types",
        162: "Troop attack when composed of all troop types",
        163: "Reduced action point consumption",
        164: "Troop speed against monster",
        165: "Resources gained from monster",
        166: "Item drop rate from monster",
        167: "March size against monster",
        168: "Increase buff duration",
        169: "Resource production per 10,000 troops",
        170: "Skill cooldown reduction",
        171: "Gathering speed per 10,000 troops",
        172: "Archer attack when invading enemy kingdoms",
        173: "Mastery point",
        174: "Christmas ornaments x2",
        175: "Resource gathering protection",
        176: "The first takeover points",
        177: "The defense points",
        178: "The final holders' bonus",
        179: "Troop health when defending",
        180: "Defense of troops when defending",
        181: "Troop attack when defending",
        182: "Infantry DEFENSE versus Archer",
        183: "Infantry ATTACK versus Archer",
        184: "Archery HP versus Cavalry",
        185: "Archery defense versus Cavalry",
        186: "Cavalry HP versus Infantry",
        187: "Cavalry DEFENSE versus Infantry",
        188: "Cavalry ATTACK versus Infantry",
        189: "Infantry ATTACK when defending castle",
        190: "Archery HP when defending castle",
        191: "Archery DEFENSE when defending castle",
        192: "Cavalry HP when defending castle",
        193: "Cavalry DEFENSE when defending castle",
        194: "Cavalry ATTACK when defending castle",
        195: "Infantry HP when participating a rally",
        196: "Infantry ATTACK when participating a rally",
        197: "Archery's DEFENSE when participating a rally",
        198: "Archery ATTACK when participating a rally",
        199: "Cavalry HP when participating a rally",
        200: "Cavalry DEFENSE when participating a rally",
        201: "Cavalry ATTACK when participating a rally",
        202: "Reconnaissance distance",
        203: "March speedup",
        204: "Archer speed when composed of archer only",
        205: "Infantry speed when composed of infantry only",
        206: "Troop HP when participating in a rally",
        207: "Troop DEFENS when participating in a rally",
        208: "Troop ATTACK when participating in a rally",
        209: "Enemy Troop HP Debuff",
        210: "Enemy Troop Defense Debuff",
        211: "Enemy Troop Attack Debuff",
        212: "drago slots",
        213: "defence drago slots",
      },
    };
  },
};
</script>
<style scoped>
.top_banner {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 312px;
}

img.top_banner_img {
  width: 100%;
  height: 240px;
  object-fit: cover;
}

.top_category {
  position: absolute;
  bottom: 0px;
  left: calc(50% - 327px);
  width: 734px;
  height: 64px;
  border-radius: 32px;
  border: solid 0 #000;
  background-color: #07071f;
  padding-top: 4px;
  padding-left: 4px;
}

.top_category_tab {
  float: left;
  width: 180px;
  height: 56px;
  margin-right: 2px;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #576288;
}

.top_category_tab.selected {
  border-radius: 28px;
  box-shadow: 0px 10px 10px 0 rgba(0, 102, 255, 0.2);
  border: solid 0 #000;
  background-image: linear-gradient(to top, #008aff, #0d6eff);
  color: #fff;
}

img.icon_drago {
  width: 30px;
  height: 24px;
  object-fit: contain;
}

img.icon_drago.selected {
  border: solid 2px #fff;
}

img.icon_land {
  width: 33px;
  height: 25px;
  object-fit: contain;
}

img.icon_land.selected {
  border: solid 2px #fff;
}

img.icon_skin {
  width: 27px;
  height: 28px;
  object-fit: contain;
}

img.icon_skin.selected {
  border: solid 2px #fff;
}

img.icon_resources {
  width: 32px;
  height: 23px;
  object-fit: contain;
}

.bg_back_button {
  width: 40px;
  height: 40px;
  padding: 9px 12px 14px 11px;
  border-radius: 20px;
  border: solid 0 #000;
  background-color: #131740;
  cursor: pointer;
}

.bg_drago {
  width: 500px;
  height: 500px;
  border-radius: 20px;
  border: solid 0 #000;
  background-color: #07071f;
}

.bg_head {
  width: 720px;
  height: 60px;
  border: solid 0 #000;
  background-color: #131740;
  cursor: pointer;
}

.text_category {
  font-family: Poppins;
  font-size: 14px;
  text-align: left;
  color: #5b6a9f;
}

.text_content {
  font-family: Poppins;
  font-size: 14px;
  text-align: left;
  color: #fff;
}

.category_line {
  width: 680px;
  height: 1px;
  border: solid 0 #1f156b;
  background-color: #1b2046;
}

.div_stat {
  margin-top: 20px;
  width: 100%;
  height: 50px;
}

.bg_stat_1 {
  width: 70px;
  height: 28px;
  border-radius: 14px;
  border: solid 0 #000;
  background-color: #232e50;
  font-family: Poppins;
  font-size: 13px;
  text-align: center;
  color: #8aa8ff;
  padding-top: 4px;
  display: inline-block;
}

.bg_stat_2 {
  width: 70px;
  height: 28px;
  border-radius: 14px;
  border: solid 0 #000;
  background-color: #fa7a1f;
  font-family: Poppins;
  font-size: 13px;
  text-align: center;
  color: #fff;
  padding-top: 4px;
  display: inline-block;
}

.bg_bonus {
  width: 70px;
  height: 28px;
  border-radius: 2px;
  border: solid 0 #000;
  background-color: #3b44bb;
  font-family: Poppins;
  font-size: 13px;
  text-align: center;
  color: #fff;
  padding-top: 5px;
  display: inline-block;
}

.selectBox {
  position: relative;
  width: 200px;
  height: 48px;
  border-radius: 8px;
  border: solid 1px #dfe5ef;
  background-color: #fff;
  font-family: Poppins;
  font-size: 14px;
  letter-spacing: -0.35px;
  text-align: left;
  color: #000;
  padding-left: 10px;
}
.selectBox .select {
  width: inherit;
  height: inherit;
  background: transparent;
  border: 0 none;
  outline: 0 none;
  padding: 0 5px;
  position: relative;
  z-index: 3;
}
.selectBox .select option {
  color: #000;
  padding: 3px 0;
  font-size: 16px;
}
.selectBox .icoArrow {
  position: absolute;
  top: 0;
  right: 0px;
  z-index: 1;
  width: 35px;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selectBox .icoArrow img {
  width: 50%;
  transition: 0.3s;
  transform: rotate(180deg);
}

.selectBox .select:focus + .icoArrow img {
  transform: rotate(0deg);
}

/* IE */
select::-ms-expand {
  display: none;
}
.select {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.line-copy-3 {
  width: 580px;
  height: 1px;
  opacity: 0.3;
  border: solid 0 #1f156b;
  background-color: #9099a8;
}

.big_frame_grade_1 {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  border: 3px solid #002aff;
}

.big_frame_grade_2 {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  border: 3px solid #b0800a;
}

.big_frame_grade_3 {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  border: 3px solid #f96e1e;
}

.big_frame_grade_4 {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  border: 3px solid #009c9a;
}
</style>
